module.exports = __webpack_public_path__ + "img/Service-tool.eba40866.svg";